import React from 'react';
import PropTypes from 'prop-types';
import { NavButtonIcon } from '../NavButton';

const CloseButton = ({ isModal, ...props }) => <NavButtonIcon alt="close button" id="closeBtn" {...props} name={isModal ? 'times': 'angle-left'} />;
CloseButton.propTypes = { isModal: PropTypes.bool };
CloseButton.defaultProps = { isModal: true };

export default CloseButton;
